export default __webpack_public_path__ + "static/media/ferven_maly.63d8f000.png";